import { withInstall } from '../utils'
import _Popup from './Popup'
import './index.scss'

export const Popup = withInstall(_Popup)
export default Popup
